import * as yup from "yup";

const schema = yup
  .object()
  .shape({
    notificationType: yup.string().required(),
    notificationText: yup.string().required(),
  })
  .required();

export default schema;
